import { useAppSelector } from '@common-reducers/hooks/store.hook';
import { shouldGetMoreContactsSelector } from '@common-reducers/WhatsAppSelectors';
import React from 'react';
import ContactRowSkeleton from './contact-row-skeleton';

const VirtuosoFooter = () => {
    const isItemsLoaded = useAppSelector(state => state.DBWaContactsCacheReducer.itemsLoaded);
    const itemsLoading = useAppSelector(state => state.DBWaContactsCacheReducer.itemsLoading);
    const shouldGetMoreContacts = useAppSelector(shouldGetMoreContactsSelector);
    // We access the list length implicitly via the fact that this footer is rendered. 
    // Ideally we only want to show this if the list has content, but Virtuoso renders Footer anyway.
    // However, the parent only renders Virtuoso if list > 0 (based on my previous edits? let's verify).
    // Actually, in the parent: if (filteredList.length === 0 && ...) return <CircularProgress />
    // So if Virtuoso is mounted, we effectively have specific behavior or an empty list state that isn't the full-page loader.
    // We want to show the skeleton ONLY if we are loading MORE items (pagination).

    // If we are strictly in "append" mode:
    if (itemsLoading || (!isItemsLoaded && shouldGetMoreContacts)) {
         return <ContactRowSkeleton />;
    }
    return null;
};

export default VirtuosoFooter;
